import { cn, linkHomePage } from '@/utils/utils';
import './style.scss';
import { Link } from 'react-router-dom';

interface BannerProps {
    url: string,
    title: string,
    subTitle: string,
    wrapperClassName?: string,
    className?: string,
    hasSubImg?: boolean
}

export default function BannerLayout({ url, title, subTitle, wrapperClassName, className, hasSubImg = false }: BannerProps) {
    return (
        <div className={cn(!hasSubImg && 'border-b border-[#FEE2E3]', className, 'overflow-hidden')}>
            <div className={cn(
                'wrapper-inner top-banner point-900:h-[300px] h-[min(250px,80vw)] flex flex-col justify-center gap-[min(30px,8vw)] relative',
                wrapperClassName
            )}
            >
                <h1 className='text-[min(36px,calc(100vw/12))] font-semibold'>{title}</h1>
                <div className='breadcrumbs'>
                    <div className='breadcrumbs-inner flex items-center relative pl-[1.5rem] gap-x-[5px] gap-y-[4em] leading-3'>
                        <Link to={linkHomePage()}>
                            <span className=''>TOP</span>
                        </Link>
                        <div className='w-[48px] border border-border-gray/70'></div>
                        <p className=''>{subTitle}</p>
                    </div>

                </div>
            </div>
        </div>

    );
}
